import { shouldPolyfill } from '@formatjs/intl-pluralrules/should-polyfill';

export const polyfill = async locale => {
  const langCode = shouldPolyfill(locale);
  if (langCode) {
    await import('@formatjs/intl-pluralrules/polyfill-force');
    await import(`@formatjs/intl-pluralrules/locale-data/${langCode}`);
  }
};
